import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface ActiveBarProps {
  selectedTab: string
  onSelectTab: (tab: string) => void
  setFilters: (filters: { [key: string]: string[] }) => void
}

const ActiveBar: React.FC<ActiveBarProps> = ({ selectedTab, onSelectTab, setFilters }) => {
  const { t } = useTranslation()

  return (
    <Box width="100%">
      <HStack spacing="24px" align="stretch" pl={5} borderBottomColor="solid.50" borderBottomWidth="1px">
        <HStack
          spacing="12px"
          py="18px"
          px="16px"
          height="56px"
          _hover={{ backgroundColor: '#D0DDFF4D' }}
          cursor="pointer"
          color="solid.900"
          onClick={() => {
            onSelectTab('active');
            setFilters({ active: ['true'] });
          }}
          borderBottomColor={selectedTab === 'active' ? 'primary.100' : 'transparent'}
          borderBottomWidth={selectedTab === 'active' ? '2px' : '0px'}
        >
          <Text textStyle="l-s">{t('common.labels.active')}</Text>
        </HStack>
        <HStack
          spacing="12px"
          py="18px"
          px="16px"
          height="56px"
          _hover={{ backgroundColor: '#D0DDFF4D' }}
          cursor="pointer"
          color="solid.900"
          onClick={()  => {
            onSelectTab('disabled');
            setFilters({ active: ['false'] });
          }}
          borderBottomColor={selectedTab === 'disabled' ? 'primary.100' : 'transparent'}
          borderBottomWidth={selectedTab === 'disabled' ? '2px' : '0px'}
        >
          <Text textStyle="l-s">{t('common.labels.disabled')}</Text>
        </HStack>
      </HStack>
    </Box>
  )
}

export default ActiveBar
